import type { ReactElement } from 'react';
import { ConfirmationDialog } from '@/components/ui/confirmation-dialog';

interface DisconnectSSODialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
  readOnly?: boolean;
}

export function DisconnectSSODialog({
  isOpen,
  onClose,
  onConfirm,
  isLoading,
  readOnly,
}: DisconnectSSODialogProps): ReactElement {
  return (
    <ConfirmationDialog
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onConfirm}
      isLoading={isLoading}
      readOnly={readOnly}
      title="Disconnect SSO?"
      description="This will clear your SSO configuration and release the email domain. Existing sessions will expire naturally. Users will then need an alternative authentication method to sign in."
      confirmLabel="Disconnect"
      confirmingLabel="Disconnecting..."
      variant="destructive"
    />
  );
}

DisconnectSSODialog.displayName = 'DisconnectSSODialog';
